import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=6d314551&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d314551",
  null
  
)

export default component.exports